// The re-check link that rides along with a destination-integrity refusal or
// an under-review code. Opens the server-rendered appeal form (the signed link
// names exactly what was refused), so it's a plain anchor, not a route.
export default function ReCheckLink({ href, className = "" }) {
  if (!href) return null
  return (
    <a
      href={href}
      className={`font-semibold text-voltage-dark dark:text-voltage-light underline underline-offset-2 hover:no-underline ${className}`}
    >
      Ask for a re-check
    </a>
  )
}
